import React from 'react'
import { IIconProps } from './Icon/Interfaces'

const PencilIcon = ({
  width=12,
  height=12,
  strokeColor='var(--blue)',
}: IIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M3.563 11.282L0 12L0.719 8.4375L3.563 11.282ZM1.426 7.73L4.27 10.5745L12 2.8445L9.1555 0L1.426 7.73Z"
        fill={strokeColor}
      />
    </svg>
  )
}

export default PencilIcon
